/* eslint-disable space-infix-ops */
/* eslint-disable indent */
import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import device from '@deprecated-ui/_style/device';
import styled, { css, keyframes } from 'styled-components';

interface StreamWidgetBoxProps {
  noBorder: boolean;
  isCompanyStock?: boolean;
  newPostCount?: number;
}

const StreamWidgetBox = styled.div<StreamWidgetBoxProps>`
  background: ${color.light};
  border: solid 1px ${color.gainsboro};
  border-radius: ${({ newPostCount }) => (newPostCount > 2 ? '0' : '3px')};

  &.guest-stream {
    flex: 1;
    max-width: 100%;

    @media ${device.tablet} {
      ${({ isCompanyStock }) => {
        if (isCompanyStock) {
          return css`
            max-width: 100%;
          `;
        }
        return css`
          max-width: calc(100% - 330px);
        `;
      }}
    }
  }

  ${({ noBorder }) =>
    noBorder &&
    css`
      border: none;
      border-radius: 4px;
    `}
`;

const StreamNewPostBox = styled(Flex).attrs({
  justify: 'center',
  align: 'center',
  py: '7px',
  // accessibility props
  role: 'button',
})`
  background-color: ${color.light};
  border: solid 1px ${color.gainsboro};
  border-bottom: none;
  cursor: pointer;
  border-radius: 3px 3px 0 0;
`;

const StreamNewPostText = styled(Text)`
  color: ${color.primary};
`;

const BackTopWrapper = styled(Flex).attrs({
  align: 'center',
  height: '40px',
  justify: 'center',
  width: '40px',
})`
  background: #a2a7b0; // this is intentionally hardcoded
  border-radius: 50%;
  bottom: 25px;
  color: ${color.light};
  right: 60px;
`;

const LineAnimation = keyframes`
  from {
    left: -200px;
    width: 30%;
  }
  50% {
    width: 30%;
  }
  70% {
    width: 70%;
  }
  80% {
    left: 50%;
  }
  95% {
    left: 120%;
  }
  to {
    left: 100%;
  }
`;

interface LineLoaderProps {
  isLoading: boolean;
}

const LineLoader = styled.div<LineLoaderProps>`
  display: block;
  height: 1px;
  width: 100%;
  position: absolute;
  top: 0;
  overflow: hidden;
  background-color: #dadada;
  display: ${({ isLoading }) => (isLoading ? 'block' : 'none')};

  :before {
    position: absolute;
    content: '';
    left: -200px;
    width: 200px;
    height: 1px;
    background-color: #00ab6b;
    animation: ${LineAnimation} 2s linear infinite;
  }
`;

const StreamWidgetWrapper = styled.div`
  position: relative;
  overflow-x: hidden;
`;

export {
  StreamWidgetWrapper,
  StreamWidgetBox,
  StreamNewPostBox,
  StreamNewPostText,
  BackTopWrapper,
  LineLoader,
};
